import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { ProcessTypeService } from 'app/shared/services/process-type.service';
import { ReportExtractService } from 'app/shared/services/reporting/report-extract.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DateHelper } from '../../misc/date.module';
import { exportToCSV } from 'app/shared/helpers/exportToCSV';
import {
  MessageBoxComponent,
  MessageBoxParameters,
  MessageBoxType,
} from 'app/components/messageBox/messageBox.component';
import { DateFormatPipe } from 'app/pipes/date-format.pipe';
import { ProcessType } from 'app/shared/models/process-type';
import { MatOption } from '@angular/material/core';
import { UserService } from 'app/shared/services/user.service';
import { User } from 'app/shared/models/user';

@Component({
  selector: 'app-report-extract',
  templateUrl: './report-extract.component.html',
  styleUrls: ['./report-extract.component.scss'],
  animations: fuseAnimations,
})
export class ReportExtractComponent implements OnInit {
  title = 'Report Extract';
  form: UntypedFormGroup;
  datasetList: any[] = [];
  processType: ProcessType;
  showProcessList = false;
  processList: any[] = [];
  stringDateFrom: String;
  stringDateTo: String;
  disableGenerate = false;
  hasExtractStarted = false;
  allowDeactivate = false;
  dialogopen = false;
  killCSV = false;
  currentUser: User;
  showIncludeArchive = false;

  @ViewChild('allProcessesSelected') private allProcessesSelected: MatOption;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private processTypeService: ProcessTypeService,
    private reportExtractService: ReportExtractService,
    private userService: UserService,
    private dateHelper: DateHelper,
    public dialog: MatDialog
  ) {

    this.currentUser = this.userService.getCurrentUser();
    // hide include archive flag if current user does not have can view archive ticked
    this.showIncludeArchive = this.currentUser.canViewArchive ? true : false;
  }

  ngOnInit() {
    this.datasetList = [
      {
        id: 1,
        name: 'Cases',
      },
      {
        id: 2,
        name: 'Processes',
      },
      {
        id: 3,
        name: 'Referrals',
      },
      {
        id: 4,
        name: 'Time Records',
      },
    ];

    this.datasetList.sort((a, b) => a.name.localeCompare(b.name));

    const processLookup$ = [];
    processLookup$.push(
      this.processTypeService
        .getAllData()
        .pipe(take(1))
        .subscribe((processTypes) => {
          if (processTypes.length > 0) {
            this.processList = [...processTypes.filter((type) => type.name !== 'Time Record' && !type.hideRecord && !type.isCheckList)];
            this.processList.sort((a, b) => a.name.localeCompare(b.name));
          }
        })
    );

    // const processFieldLookup$ = []
    // processFieldLookup$.push(this.dataFieldService.getAvailableDataTypes().subscribe((datatypes) => {
    //   if (datatypes.length > 0) {
    //     this.processFieldList = [...datatypes.filter(datatype => datatype.)]
    //   }
    // }))

    this.form = this.formBuilder.group(
      {
        dataset: ['', [Validators.required]],
        //process: this.processList,

        dateFrom: [null, [Validators.required]],
        dateTo: [null, [Validators.required]],
        includeArchived: false,
      },
      { validator: this.valMinMax }
    );
  }

  valMinMax: ValidatorFn = (control: UntypedFormGroup) => {
    let minDate = null;
    let maxDate = null;
    minDate = this.dateHelper.relativeToAbsolute(control.get('dateFrom').value);
    if (minDate) {
      minDate = minDate.valueOf();
    }
    maxDate = this.dateHelper.relativeToAbsolute(control.get('dateTo').value);
    if (maxDate) {
      maxDate = maxDate.valueOf();
    }
    if (maxDate && minDate) {
      let error = minDate > maxDate;
      if (!error) {
        error =
          this.dateHelper.isRelativeDate(control.get('dateFrom').value) &&
          !this.dateHelper.isRelativeDate(control.get('dateTo').value);
      }
      if (error) return error ? { minmaxerror: true } : null;
    } else {
      return null;
    }
  };

  datasetChange(event) {
    if (event.value == 'Processes') {
      this.form.addControl(
        'process',
        new UntypedFormControl(null, Validators.required)
      );
      this.showProcessList = true;
    } else {
      this.form.removeControl('process');
      this.showProcessList = false;
    }
  }

  toggleProcessAllSelection() {
    if (this.allProcessesSelected.selected) {
      this.form.controls.process.patchValue([
        ...this.processList.map((item) => item.name),
        0,
      ]);
    } else {
      this.form.controls.process.patchValue([]);
    }
  }

  toggleProcessPerOne() {
    if (this.allProcessesSelected) {
      if (this.allProcessesSelected.selected) {
        this.allProcessesSelected.deselect();
        return false;
      }
      if (this.form.controls.process.value.length === this.processList.length) {
        this.allProcessesSelected.select();
      }
    }
  }

  processChange(opened: boolean) {
    if (this.allProcessesSelected) {
      if (
        opened &&
        this.form.controls.process.value &&
        this.processList &&
        this.form.controls.process.value.length === this.processList.length
      ) {
        this.allProcessesSelected.select();
      } else {
        this.allProcessesSelected.deselect();
      }
    }
  }

  fromDateChange(event) {
    //console.log(event.replace(/\//g, ' '));
    //this.stringDateFrom = event.replace(/\//g, '-');
  }

  toDateChange(event) {
    //console.log(event);
  }

  canDeactivate(): Observable<boolean> | boolean {
    // unsaved changes if hasChanges flag set to true
    const unsavedChanges = this.allowDeactivate;
    if (!unsavedChanges) {
      // no changes, so return true
      return true;
    } else {
      this.dialogopen = true;
      // possible a while loop to keep checking for this.allowDeactivate, pretty messy though
      // changes pending, prompt user
      const info = new MessageBoxParameters(
        'Report Extract has not finished generating.  Discard?',
        'Report Extract Incomplete',
        MessageBoxType.YesNo
      );
      return this.dialog
        .open(MessageBoxComponent, { data: info })
        .afterClosed()
        .pipe(
          map((result) => {
            this.dialogopen = false;
            result === 'yes' ? (this.killCSV = true) : (this.killCSV = false);
            return result === 'yes';
          })
        );
    }
  }

  generateExtract() {
    this.hasExtractStarted = true;
    this.allowDeactivate = true;
    const extract = this.form.getRawValue();
    // extract.controls.dateFrom.patchValue(
    //   extract.dateFrom && extract.dateFrom.length > 0
    //     ? new Date(extract.dateFrom.replace(/ /g, '/'))
    //     : ''
    // );
    // extract.controls.dateTo.patchValue(
    //   extract.dateTo && extract.dateTo.length > 0
    //     ? new Date(extract.dateTo.replace(/ /g, '/'))
    //     : ''
    // );
    this.form.markAsPristine();
    //console.log(this.dateHelper.parse(extract.dateFrom));
    extract.process =
      extract.process && Array.isArray(extract.process)
        ? extract.process.join()
        : extract.process;
    extract.dateFrom = new DateFormatPipe('en-GB')
      .transform(extract.dateFrom)
      .replaceAll('/', '-');
    extract.dateTo = new DateFormatPipe('en-GB')
      .transform(extract.dateTo)
      .replaceAll('/', '-');
    const extractObj = {
      dataset: extract.dataset,
      process: extract.process,
      dateFrom: extract.dateFrom,
      dateTo: extract.dateTo,
      includeArchived: extract.includeArchived,
    };
    //console.log(extractObj);
    this.reportExtractService
      .generateExtract(extractObj)
      .subscribe((result) => {
        const resultTest = result;
        if (this.dialogopen) {
          this.dialog.closeAll();
        }
        if (resultTest && resultTest != '[]' && resultTest.length > 0) {
          this.hasExtractStarted = false;
          this.allowDeactivate = false;
          //console.log(resultTest);
          const now = new Date();
          let dateString = now
            .toLocaleString('en-GB', { timeZone: 'Europe/London' })
            .replace(', ', '@');
          const fileName = extractObj.process
            ? `${extractObj.process}_Extract_${dateString}`
            : `${extractObj.dataset}_Extract_${dateString}`;
          if (!this.killCSV) {
            exportToCSV.FromJSON(fileName, result);
          }          
          //we would want to save it as a csv or here we ask what they want.
        } else {
          const info = new MessageBoxParameters(
            'No Records Found',
            'Failed to Generate Report Extract',
            MessageBoxType.Ok
          );
          this.hasExtractStarted = false;
          this.allowDeactivate = false;
          return this.dialog.open(MessageBoxComponent, { data: info });
        }
      });
  }

  //all subject types that arent hidden and referrals and processes
}
